module.exports = __webpack_public_path__ + "assets/img/search.00e46ec8.svg";